import Link from "next/link";
import { useRouter } from "next/router";
import styled from "styled-components";

import type { Post } from "../.tina/__generated__/types";
import { displayDate } from "../src/utils";

import { CategoryIconAndName } from "./categoryIcon/CategoryIcon";

const StyledDiv = styled.div`
  margin: -10px var(--panel-padding-neg) 30px var(--panel-padding-neg);
  padding: 10px var(--panel-padding) 10px var(--panel-padding);

  &:target {
    background-color: var(--highlight-color);
  }
`;

function PostInCategory({ node }: { node: Post }) {
  const { locale } = useRouter();
  return (
    <li>
      <Link href={`/post/${node._sys.filename}`}>{node.title}</Link>,{" "}
      <span className="entry-date">
        <time dateTime={node.date} itemProp="datePublished">
          {displayDate(node.date, locale)}
        </time>
      </span>
    </li>
  );
}

export default function Category({
  categoryName,
  posts,
}: {
  categoryName: string;
  posts: Post[];
}) {
  return (
    <StyledDiv id={categoryName.toLowerCase()}>
      <h3>
        <CategoryIconAndName categoryName={categoryName} />
      </h3>
      <ul>
        {posts.map((post) => (
          <PostInCategory key={post.id} node={post} />
        ))}
      </ul>
    </StyledDiv>
  );
}
